// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hVpwH","requiredAsterisk":"Info_requiredAsterisk__2hH7r"};